import ImageUpload from './ImageUpload.vue';

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/FcComponents/ImageUpload/index.js